import React, { useEffect } from "react";
import {
  Routes,
  Route,
  BrowserRouter,
  Navigate,
  useLocation
} from "react-router-dom";

import "react-tippy/dist/tippy.css";

import Landing from "./Landing";
import Page from "./Page";
import PlanMER from "./PlanMER";
import PlanMER05052022 from "./PlanMER05052022";
import menuitemsDataEnergietransitie from "./data/menuEnergietransitie";
import menuitemsDataEnergietransitie05052022 from "./data/menuEnergietransitie-05-05-2022";



const Main = () => {

  function ScrollToTop() {
    const { pathname } = useLocation();    

    useEffect(() => {
      window.scrollTo(0, 0);      
    }, [pathname]);

    return null;
  }


  return (

    <BrowserRouter>
      <ScrollToTop />
        <Routes>
            <Route path="/energietransitie/" element={<Navigate to="/energietransitie/samenvatting" />} />

              { menuitemsDataEnergietransitie["menu"].map((item) => item.children.length ? (
                    <>
                      <Route
                        key={item.link}
                        path={item.link}
                        element={<PlanMER {...item.data} />}
                      />
                      { item.children.filter((child) => !child.link.includes("#")).map((child) => (
                        <>
                        <Route
                          key={child.link}
                          path={child.link}
                          element={<PlanMER {...child.data} />}
                        />

                        {child.children.filter((superChild) => !superChild.link.includes("#")).map((superChild) => (
                          <Route
                            key={superChild.link}
                            path={superChild.link}
                            element={<PlanMER {...superChild.data} />}
                          />                      
                        ))}

                        </>
                      ))}
                    </>
                  ) : (
                    <Route
                      key={item.link}
                      path={item.link}
                      element={<PlanMER {...item.data} />}
                    />
                  )
                )}

              { menuitemsDataEnergietransitie05052022["menu"].map((item) => item.children.length ? (
                    <>
                      <Route
                        key={item.link}
                        path={item.link}
                        element={<PlanMER05052022 {...item.data} />}
                      />
                      { item.children.filter((child) => !child.link.includes("#")).map((child) => (
                        <>
                        <Route
                          key={child.link}
                          path={child.link}
                          element={<PlanMER05052022 {...child.data} />}
                        />

                        {child.children.filter((superChild) => !superChild.link.includes("#")).map((superChild) => (
                          <Route
                            key={superChild.link}
                            path={superChild.link}
                            element={<PlanMER05052022 {...superChild.data} />}
                          />                      
                        ))}

                        </>
                      ))}
                    </>
                  ) : (
                    <Route
                      key={item.link}
                      path={item.link}
                      element={<PlanMER05052022 {...item.data} />}
                    />
                  )
                )}  

            <Route path="/lot-omgevingsvisie-2019/" element={<Page path="/lot-omgevingsvisie-2019/" key="lot-2019" />} />
            <Route path="/zuidplaspolder/" element={<Page path="/zuidplaspolder/" key="zp" />} />
            <Route path="/gnephoek/" element={<Page path="/gnephoek/" key="g" />} />
            <Route path="/" element={<Landing />} />
          </Routes>
    </BrowserRouter>
  );
};


export default Main;
